import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Mail, ArrowLeft, Terminal, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API_URL = 'https://cyberguard-api-ka8f.onrender.com';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError('Une erreur est survenue. Réessayez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-6">
      <div className="w-full max-w-md space-y-8">

        {/* Logo */}
        <div className="text-center">
          <Link to="/" className="inline-flex items-center gap-2 mb-6">
            <ShieldCheck className="w-10 h-10 text-blue-500" />
            <span className="font-mono text-2xl font-black text-white uppercase tracking-tighter">CyberGuard</span>
          </Link>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-500/10 border border-blue-500/20 mb-4">
            <Terminal className="w-3 h-3 text-blue-400" />
            <span className="text-blue-400 text-[10px] font-mono uppercase tracking-widest">Password_Recovery</span>
          </div>
          <h1 className="text-2xl font-black text-white font-mono uppercase tracking-tighter">Mot de passe oublié</h1>
          <p className="text-zinc-500 text-xs font-mono mt-1 uppercase tracking-widest">
            Entrez votre email pour recevoir un lien de réinitialisation
          </p>
        </div>

        {sent ? (
          /* Message de confirmation */
          <div className="bg-green-500/5 border border-green-500/30 rounded-sm p-8 text-center space-y-4">
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto" />
            <h2 className="text-white font-mono font-bold uppercase">Email envoyé !</h2>
            <p className="text-zinc-400 font-mono text-xs leading-relaxed">
              Si un compte existe avec l'adresse <span className="text-white">{email}</span>, 
              vous recevrez un lien de réinitialisation dans quelques minutes.
            </p>
            <p className="text-zinc-600 font-mono text-[10px]">Vérifiez aussi vos spams.</p>
            <Link to="/login" className="inline-flex items-center gap-2 text-blue-400 font-mono text-xs uppercase hover:text-blue-300 transition-colors mt-4">
              <ArrowLeft className="w-3 h-3" /> Retour à la connexion
            </Link>
          </div>
        ) : (
          /* Formulaire */
          <div className="bg-zinc-900/50 border border-zinc-800 p-8 rounded-sm relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-blue-500/0 via-blue-500 to-blue-500/0 opacity-50" />

            <form onSubmit={handleSubmit} className="space-y-5">
              {error && (
                <div className="p-3 bg-red-500/10 border-l-2 border-red-500 text-red-400 text-xs font-mono">
                  {error}
                </div>
              )}

              <div className="space-y-1">
                <label htmlFor="forgot-email" className="text-xs font-bold text-blue-400 font-mono tracking-widest uppercase">
                  Adresse email
                </label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-600" />
                  <input
                    id="forgot-email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="vous@entreprise.com"
                    className="w-full bg-black border border-zinc-800 p-3 pl-10 text-white font-mono text-sm focus:border-blue-500 outline-none transition-all placeholder:text-zinc-700"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white py-4 font-black font-mono uppercase text-sm rounded-none transition-all"
              >
                {loading ? <span className="animate-pulse">Envoi…</span> : 'Envoyer le lien'}
              </button>
            </form>

            <div className="mt-6 text-center">
              <Link to="/login" className="flex items-center justify-center gap-2 text-zinc-500 hover:text-white font-mono text-xs uppercase transition-colors">
                <ArrowLeft className="w-3 h-3" /> Retour à la connexion
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
